import { ActionTree } from "vuex";
import { RootState } from "@/models/states/RootState";

const actions: ActionTree<RootState, RootState> = {};
export default actions;
